import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserCircle, LogOut } from 'lucide-react';

const routeLabels = {
  '/':             'Dashboard',
  '/engage':       'Engage RAAH',
  '/materials':    'Materials',
  '/booking':      'Book Time',
  '/capabilities': 'Capabilities',
  '/ask':          'Ask a Question',
  '/marketplace':  'Marketplace',
  '/workshops':    'Workshops & Events',
  '/my-requests':  'My Requests',
  '/profile':      'Profile',
  '/admin':        'Admin Console',
};

const styles = {
  topbar: {
    height: '52px',
    background: '#fff',
    borderBottom: '1px solid #e5e5e5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 24px',
    flexShrink: 0,
  },
  title: {
    fontSize: '15px',
    fontWeight: '600',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  iconBtn: {
    background: 'none',
    border: 'none',
    padding: '6px',
    borderRadius: '8px',
    cursor: 'pointer',
    color: '#555',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background 0.15s, color 0.15s',
  },
};

function TopBar() {
  const { user, logout } = useAuth0();
  const location = useLocation();
  const navigate = useNavigate();
  const title = routeLabels[location.pathname] || 'RAAH Portal';

  return (
    <header style={styles.topbar}>
      <div style={styles.title}>{title}</div>
      <div style={styles.right}>
        <button
          style={styles.iconBtn}
          onClick={() => navigate('/profile')}
          title={user?.name || user?.email || 'Profile'}
          onMouseEnter={e => { e.currentTarget.style.background = '#f5f5f5'; e.currentTarget.style.color = '#111'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = '#555'; }}
        >
          <UserCircle size={22} strokeWidth={1.75} />
        </button>
        <button
          style={styles.iconBtn}
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          title="Log out"
          onMouseEnter={e => { e.currentTarget.style.background = '#fff5f5'; e.currentTarget.style.color = '#c92a2a'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = '#555'; }}
        >
          <LogOut size={20} strokeWidth={1.75} />
        </button>
      </div>
    </header>
  );
}

export default TopBar;